import { MappingTabConfig } from './client-data-mapping-constants';

const READ_ONLY_HIDDEN_COLUMNS = new Set<string | undefined>(['select', 'actions']);

const SHARED_DRIVE_ID_PATTERN = /^0A[A-Za-z0-9_-]+$/;

export const isReadOnlyTab = (
  tab: Pick<MappingTabConfig, 'adminOnlyEdit'>,
  isAdmin: boolean
): boolean => Boolean(tab.adminOnlyEdit) && !isAdmin;

export const filterReadOnlyHeaders = <T extends { name?: string }>(
  headers: T[],
  readOnly: boolean
): T[] =>
  readOnly ? headers.filter(header => !READ_ONLY_HIDDEN_COLUMNS.has(header.name)) : headers;

export const isValidSharedDriveId = (value: string): boolean => SHARED_DRIVE_ID_PATTERN.test(value);
